<template>
  <el-dialog
    width="400px"
    custom-class="dialog-contact-form"
    :visible="show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('hide')"
  >
    <div slot="title" class="title tc fs18 m-b-4" style="color: #2fa0ff">通过连尚广告获取更多客户</div>
    <el-form ref="form" :rules="rules" :model="formData" label-width="0">
      <el-form-item label="" prop="name">
        <el-input v-model="formData.name" placeholder="姓名"></el-input>
      </el-form-item>
      <el-form-item label="" prop="phone">
        <el-input v-model="formData.phone" maxlength="11" placeholder="手机号码"></el-input>
      </el-form-item>
      <el-form-item label="" prop="companyName">
        <el-input v-model="formData.companyName" placeholder="公司名称"></el-input>
      </el-form-item>
      <el-form-item label="" prop="district" @click.native="getRegionTree">
        <el-cascader
          class="full-width"
          v-model="formData.district"
          :options="addressOptions"
          :props="{ value: 'name', label: 'name', children: 'child' }"
          placeholder="地址"
        ></el-cascader>
      </el-form-item>
    </el-form>
    <div class="tc">您的专属顾问会在1个工作日内联系您，为您提供服务</div>
    <div class="tc m-t-1 m-b-3"><span class="m-r-2">周一至周五09:00-22:00</span><span>周六至周日09:00-18:00</span></div>
    <div class="tc">
      <el-button type="primary" class="full-width" @click="doSubmitInternal" :disabled="submitting">立即提交</el-button>
    </div>
  </el-dialog>
</template>
<script>
import contactFormMixin from '@/mixins/contactForm';
export default {
  name: '',
  mixins: [contactFormMixin],
  props: {
    show: { type: Boolean, default: false },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    doSubmitInternal() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.doSubmit()
          .then(() => {
            this.$message.success('提交成功');
            this.$emit('hide');
          })
          .catch(() => {
            this.$message.error('提交失败，请重试');
          });
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss">
.dialog-contact-form {
  .el-dialog__body {
    padding: 0 30px 30px;
  }
  .el-dialog__header {
    letter-spacing: 1px;
  }
  .el-form-item__content {
    .el-input {
      width: 100%;
    }
    .el-input__inner {
      border-width: 0 0 1px 0;
      border-radius: 0;
    }
  }
}
</style>
